import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/index',
      name: 'index',
      meta: {
        title: '首页'
      },
      component: resolve => {
        require(['@/pages/index.vue'], resolve)
      }
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '登录'
      },
      component: resolve => {
        require(['@/pages/login.vue'], resolve)
      }
    },
    {
      path: '/regUser',
      name: 'regUser',
      meta: {
        title: '注册用户'
      },
      component: resolve => {
        require(['@/pages/regUser.vue'], resolve)
      }
    },
    {
      path: '/userDetail',
      name: 'userDetail',
      meta: {
        title: '用户详情'
      },
      component: resolve => {
        require(['@/pages/userDetail.vue'], resolve)
      }
    },
    {
      path: '/agent',
      name: 'agent',
      meta: {
        title: '代理用户'
      },
      component: resolve => {
        require(['@/pages/agent.vue'], resolve)
      }
    },
    {
      path: '/agentDetail',
      name: 'agentDetail',
      meta: {
        title: '代理用户详情'
      },
      component: resolve => {
        require(['@/pages/agentDetail.vue'], resolve)
      }
    },
    {
      path: '/blacklist',
      name: 'blacklist',
      meta: {
        title: '黑名单'
      },
      component: resolve => {
        require(['@/pages/blacklist.vue'], resolve)
      }
    },
    {
      path: '/blackDetail',
      name: 'blackDetail',
      meta: {
        title: '黑名单详情'
      },
      component: resolve => {
        require(['@/pages/blackDetail.vue'], resolve)
      }
    },
    {
      path: '/commission',
      name: 'commission',
      meta: {
        title: '详情'
      },
      component: resolve => {
        require(['@/pages/commission.vue'], resolve)
      }
    },
    {
      path: '/whiteList',
      name: 'whiteList',
      meta: {
        title: '白名单'
      },
      component: resolve => {
        require(['@/pages/whiteList.vue'], resolve)
      }
    },
    {
      path: '/order',
      name: 'order',
      meta: {
        title: '商城订单'
      },
      component: resolve => {
        require(['@/pages/order.vue'], resolve)
      }
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      meta: {
        title: '订单详情'
      },
      component: resolve => {
        require(['@/pages/orderDetail.vue'], resolve)
      }
    },
    {
      path: '/selforder',
      name: 'selforder',
      meta: {
        title: '自提订单'
      },
      component: resolve => {
        require(['@/pages/selforder.vue'], resolve)
      }
    },
    {
      path: '/selforderDetail',
      name: 'selforderDetail',
      meta: {
        title: '订单详情'
      },
      component: resolve => {
        require(['@/pages/selforderDetail.vue'], resolve)
      }
    },
    {
      path: '/winningOrder',
      name: 'winningOrder',
      meta: {
        title: '中奖兑奖商品订单'
      },
      component: resolve => {
        require(['@/pages/winningOrder.vue'], resolve)
      }
    },
    {
      path: '/winningOrderDetail',
      name: 'winningOrderDetail',
      meta: {
        title: '订单详情'
      },
      component: resolve => {
        require(['@/pages/winningOrderDetail.vue'], resolve)
      }
    },
    {
      path: '/commodity',
      name: 'commodity',
      meta: {
        title: '商品管理'
      },
      component: resolve => {
        require(['@/pages/commodity.vue'], resolve)
      }
    },
    {
      path: '/activityComm',
      name: 'activityComm',
      meta: {
        title: '抽奖商品管理'
      },
      component: resolve => {
        require(['@/pages/activityComm.vue'], resolve)
      }
    },
    {
      path: '/addActivityComm',
      name: 'addActivityComm',
      meta: {
        title: '添加活动商品'
      },
      component: resolve => {
        require(['@/pages/addActivityComm.vue'], resolve)
      }
    },
    {
      path: '/editActivityComm',
      name: 'editActivityComm',
      meta: {
        title: '编辑活动商品'
      },
      component: resolve => {
        require(['@/pages/editActivityComm.vue'], resolve)
      }
    },
    {
      path: '/addCommo',
      name: 'addCommo',
      meta: {
        title: '添加商品'
      },
      component: resolve => {
        require(['@/pages/addCommo.vue'], resolve)
      }
    },
    {
      path: '/editCommo',
      name: 'editCommo',
      meta: {
        title: '商品编辑'
      },
      component: resolve => {
        require(['@/pages/editCommo.vue'], resolve)
      }
    },
    {
      path: '/trademark',
      name: 'trademark',
      meta: {
        title: '商品标签管理'
      },
      component: resolve => {
        require(['@/pages/trademark.vue'], resolve)
      }
    },
    {
      path: '/carMy',
      name: 'carMy',
      meta: {
        title: '卡密管理'
      },
      component: resolve => {
        require(['@/pages/carMy.vue'], resolve)
      }
    },
    {
      path: '/role',
      name: 'role',
      meta: {
        title: '角色管理'
      },
      component: resolve => {
        require(['@/pages/role.vue'], resolve)
      }
    }, {
      path: '/account',
      name: 'account',
      meta: {
        title: '账号管理'
      },
      component: resolve => {
        require(['@/pages/account.vue'], resolve)
      }
    }
    , {
      path: '/jurisdiction',
      name: 'jurisdiction',
      meta: {
        title: '权限管理'
      },
      component: resolve => {
        require(['@/pages/jurisdiction.vue'], resolve)
      }
    },
    {
      path: '/roleDetail',
      name: 'roleDetail',
      meta: {
        title: '修改'
      },
      component: resolve => {
        require(['@/pages/roleDetail.vue'], resolve)
      }
    },
    {
      path: '/category',
      name: 'category',
      meta: {
        title: '类目管理'
      },
      component: resolve => {
        require(['@/pages/category.vue'], resolve)
      }
    },
    {
      path: '/channel',
      name: 'channel',
      meta: {
        title: '渠道管理'
      },
      component: resolve => {
        require(['@/pages/channel.vue'], resolve)
      }
    },
    {
      path: '/welfare',
      name: 'welfare',
      meta: {
        title: '每日福利抽奖'
      },
      component: resolve => {
        require(['@/pages/welfare.vue'], resolve)
      }
    },
    {
      path: '/welfareDetail',
      name: 'welfareDetail',
      meta: {
        title: '每日福利抽奖编辑'
      },
      component: resolve => {
        require(['@/pages/welfareDetail.vue'], resolve)
      }
    },
    {
      path: '/welfareBack',
      name: 'welfareBack',
      meta: {
        title: '每日福利返佣'
      },
      component: resolve => {
        require(['@/pages/welfareBack.vue'], resolve)
      }
    },
    {
      path: '/ranking',
      name: 'ranking',
      meta: {
        title: '排行榜'
      },
      component: resolve => {
        require(['@/pages/ranking.vue'], resolve)
      }
    },
    {
      path: '/invitation',
      name: 'invitation',
      meta: {
        title: '邀请设置'
      },
      component: resolve => {
        require(['@/pages/invitation.vue'], resolve)
      }
    },
    {
      path: '/dryingSheet',
      name: 'dryingSheet',
      meta: {
        title: '晒单管理'
      },
      component: resolve => {
        require(['@/pages/dryingSheet.vue'], resolve)
      }
    },
    {
      path: '/platformDrying',
      name: 'platformDrying',
      meta: {
        title: '平台晒单'
      },
      component: resolve => {
        require(['@/pages/platformDrying.vue'], resolve)
      }
    },
    {
      path: '/withdrawal',
      name: 'withdrawal',
      meta: {
        title: '提现管理'
      },
      component: resolve => {
        require(['@/pages/withdrawal.vue'], resolve)
      }
    },
    {
      path: '/integral',
      name: 'integral',
      meta: {
        title: '缘钻商品回收'
      },
      component: resolve => {
        require(['@/pages/integral.vue'], resolve)
      }
    },
    {
      path: '/integralMony',
      name: 'integralMony',
      meta: {
        title: '现金商品回收'
      },
      component: resolve => {
        require(['@/pages/integralMony.vue'], resolve)
      }
    },
    {
      path: '/withdrawReview',
      name: 'withdrawReview',
      meta: {
        title: '提现审核（线上）'
      },
      component: resolve => {
        require(['@/pages/withdraw/index.vue'], resolve)
      }
    },
    {
      path: '/offlineWithdrawReview',
      name: 'offlineWithdrawReview',
      meta: {
        title: '提现审核（线下）'
      },
      component: resolve => {
        require(['@/pages/withdraw/offlineWithdrawReview.vue'], resolve)
      }
    },
    {
      path: '/withdrawRecord',
      name: 'withdrawRecord',
      meta: {
        title: '余额明细'
      },
      component: resolve => {
        require(['@/pages/withdraw/record.vue'], resolve)
      }
    },
    {
      path: '/paymentChannel',
      name: 'paymentChannel',
      meta: {
        title: '渠道管理'
      },
      component: resolve => {
        require(['@/pages/payment/channel.vue'], resolve)
      }
    },
    {
      path: '/releaseAudit',
      name: 'releaseAudit',
      meta: {
        title: '积分发放审核'
      },
      component: resolve => {
        require(['@/pages/releaseAudit.vue'], resolve)
      }
    },
    {
      path: '/integralDetail',
      name: 'integralDetail',
      meta: {
        title: '积分发放详情'
      },
      component: resolve => {
        require(['@/pages/integralDetail.vue'], resolve)
      }
    },
    {
      path: '/releaseDetail',
      name: 'releaseDetail',
      meta: {
        title: '积分发放审核详情'
      },
      component: resolve => {
        require(['@/pages/releaseDetail.vue'], resolve)
      }
    },
    {
      path: '/supplier',
      name: 'supplier',
      meta: {
        title: '供应商管理'
      },
      component: resolve => {
        require(['@/pages/supplier.vue'], resolve)
      }
    },
    {
      path: '/addSupplier',
      name: 'addSupplier',
      meta: {
        title: '添加供应商'
      },
      component: resolve => {
        require(['@/pages/addSupplier.vue'], resolve)
      }
    },
    {
      path: '/editSupplier',
      name: 'editSupplier',
      meta: {
        title: '编辑供应商'
      },
      component: resolve => {
        require(['@/pages/editSupplier.vue'], resolve)
      }
    },
    {
      path: '/prizeAdmin',
      name: 'prizeAdmin',
      meta: {
        title: '抽奖管理'
      },
      component: resolve => {
        require(['@/pages/prizeAdmin.vue'], resolve)
      }
    },
    {
      path: '/prizeDetail',
      name: 'prizeDetail',
      meta: {
        title: '抽奖详情'
      },
      component: resolve => {
        require(['@/pages/prizeDetail.vue'], resolve)
      }
    },
    {
      path: '/stockAdmin',
      name: 'stockAdmin',
      meta: {
        title: '库存管理'
      },
      component: resolve => {
        require(['@/pages/stockAdmin.vue'], resolve)
      }
    },
  ]
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js